import { useTranslation } from "react-i18next";

export default function TermsPage() {
  const { t, i18n } = useTranslation("admin");
  const isEnglish = i18n.resolvedLanguage?.toLowerCase().startsWith("en");

  const termsEmailHref = `mailto:info@buukkeri.fi?subject=${encodeURIComponent(
    t("termsPage.contact.emailSubject")
  )}`;

  return (
    <main className="min-h-screen bg-zinc-950 px-4 py-12 text-white sm:px-6">
      <section className="mx-auto max-w-3xl rounded-[2rem] border border-white/10 bg-white/[0.04] p-6 shadow-2xl sm:p-8">
        <nav className="mb-8 flex flex-wrap items-center gap-3 text-xs font-black uppercase tracking-[0.14em]">
          <a
            href={isEnglish ? "/en/" : "/"}
            className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-white no-underline transition hover:border-red-400 hover:bg-red-500/10"
          >
            {t("termsPage.nav.home")}
          </a>

          <a
            href="/yhteys"
            className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-zinc-300 no-underline transition hover:border-red-400 hover:text-white"
          >
            {t("termsPage.nav.contact")}
          </a>

          <a
            href={isEnglish ? "/en/privacy" : "/tietosuoja"}
            className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-zinc-300 no-underline transition hover:border-red-400 hover:text-white"
          >
            {t("termsPage.nav.privacy")}
          </a>

          <span className="rounded-full border border-red-400/30 bg-red-500/10 px-4 py-2 text-red-100">
            {t("termsPage.nav.terms")}
          </span>
        </nav>

        <p className="text-xs font-black uppercase tracking-[0.22em] text-red-400">
          Paranoidi
        </p>

        <h1 className="mt-4 text-4xl font-black tracking-tight text-white sm:text-5xl">
          {t("termsPage.title")}
        </h1>

        <p className="mt-5 text-base leading-7 text-zinc-300">
          {t("termsPage.intro")}
        </p>

        <p className="mt-4 text-sm leading-7 text-zinc-500">
          {t("termsPage.updated")}
        </p>

        <div className="mt-8 grid gap-5 text-sm leading-6 text-zinc-400">
          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.provider.title")}
            </h2>

            <div className="mt-2 grid gap-1">
              <p>Spiderlegs Productions</p>
              <p>{t("termsPage.provider.businessId")}</p>
              <p>{t("termsPage.provider.address")}</p>
              <p>
                {t("termsPage.provider.emailLabel")}{" "}
                <a
                  href="mailto:info@buukkeri.fi"
                  className="font-bold text-white underline-offset-4 hover:underline"
                >
                  info@buukkeri.fi
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.use.title")}
            </h2>
            <p className="mt-2">{t("termsPage.use.p1")}</p>
            <p className="mt-2">{t("termsPage.use.p2")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.userContent.title")}
            </h2>
            <p className="mt-2">{t("termsPage.userContent.p1")}</p>
            <p className="mt-2">{t("termsPage.userContent.p2")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.requests.title")}
            </h2>
            <p className="mt-2">{t("termsPage.requests.p1")}</p>
            <p className="mt-2">{t("termsPage.requests.p2")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.plans.title")}
            </h2>
            <p className="mt-2">{t("termsPage.plans.p1")}</p>
            <p className="mt-2">{t("termsPage.plans.p2")}</p>
            <p className="mt-2">{t("termsPage.plans.p3")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.withdrawal.title")}
            </h2>
            <p className="mt-2">{t("termsPage.withdrawal.p1")}</p>
            <p className="mt-2">{t("termsPage.withdrawal.p2")}</p>
            <p className="mt-2">{t("termsPage.withdrawal.p3")}</p>
            <p className="mt-2">{t("termsPage.withdrawal.p4")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.printProducts.title")}
            </h2>
            <p className="mt-2">{t("termsPage.printProducts.p1")}</p>
            <p className="mt-2">{t("termsPage.printProducts.p2")}</p>
            <p className="mt-2">{t("termsPage.printProducts.p3")}</p>
            <p className="mt-2">{t("termsPage.printProducts.p4")}</p>
            <p className="mt-2">{t("termsPage.printProducts.p5")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.availability.title")}
            </h2>
            <p className="mt-2">{t("termsPage.availability.p1")}</p>
            <p className="mt-2">{t("termsPage.availability.p2")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.liability.title")}
            </h2>
            <p className="mt-2">{t("termsPage.liability.p1")}</p>
            <p className="mt-2">{t("termsPage.liability.p2")}</p>
            <p className="mt-2">{t("termsPage.liability.p3")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.changes.title")}
            </h2>
            <p className="mt-2">{t("termsPage.changes.p1")}</p>
            <p className="mt-2">{t("termsPage.changes.p2")}</p>
          </section>

          <section>
            <h2 className="text-lg font-black text-white">
              {t("termsPage.contact.title")}
            </h2>

            <p className="mt-2">
              {t("termsPage.contact.beforeEmail")}{" "}
              <a
                href={termsEmailHref}
                className="font-bold text-white underline-offset-4 hover:underline"
              >
                info@buukkeri.fi
              </a>
              .
            </p>
          </section>
        </div>
      </section>
    </main>
  );
}
